import autoComplete from "@tarekraafat/autocomplete.js";

document.addEventListener("DOMContentLoaded", function () {

  if (typeof NOURIA_VARS === "undefined") {
    return false;
  }

  if (typeof NOURIA_VARS.site_url === "undefined") {
    return false;
  }

  const searchInput = document.getElementById("locationSearch");

  // Only proceed if locationSearch element exists
  if (searchInput) {
    // Check for all required DOM elements upfront
    const requiredElements = {
      locationsList: document.querySelector(".locations-list"),
      locationImage: document.getElementById("location-image"),
      locationImageLink: document.getElementById("location-image-link"),
      locationTitle: document.getElementById("location-title"),
      locationAddress: document.getElementById("location-address"),
      moreInfoLink: document.getElementById("more-info-link")
    };

    // Verify all required elements exist
    const missingElements = Object.entries(requiredElements)
      .filter(([_, element]) => !element)
      .map(([name]) => name);

    if (missingElements.length > 0) {
      console.warn(`Missing required DOM elements: ${missingElements.join(', ')}`);
      return;
    }

    // Destructure elements for use in the rest of the code
    const {
      locationsList,
      locationImage,
      locationImageLink,
      locationTitle,
      locationAddress,
      moreInfoLink
    } = requiredElements;

    let locations = [];

    // Add this function at the top level
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // ✅ Fetch locations from API
    async function fetchLocations() {
      try {
        const response = await fetch(NOURIA_VARS.site_url + "/wp-json/nouria/v1/locations");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        // Validate the data structure
        if (!Array.isArray(data)) {
          throw new Error('Invalid data format: expected an array of locations');
        }

        locations = data;
        attachEventListenersToDefaultLocations();
      } catch (error) {
        console.error("Error fetching locations:", error);
        locationsList.innerHTML = `<li class="no-results">Unable to load locations. Please try again later.</li>`;
      }
    }

    // ✅ Show the autocomplete list
    function ensureAutoCompleteVisibility() {
      const autoCompleteList = document.querySelector(".autoComplete_list");
      if (autoCompleteList) {
        autoCompleteList.style.display = "block";
      }
    }

    // ✅ Hide the autocomplete list
    function hideAutoCompleteList() {
      const autoCompleteList = document.querySelector(".autoComplete_list");
      if (autoCompleteList) {
        autoCompleteList.style.display = "none";
      }
    }

    // ✅ Attach click event to default locations
    function attachEventListenersToDefaultLocations() {
      document.querySelectorAll(".locations-list-link").forEach(link => {
        link.addEventListener("click", function(e) {
          e.preventDefault();

          const locationData = {
            id: this.getAttribute("data-id").replace("location-card-", ""),
            title: this.getAttribute("data-title"),
            address: this.getAttribute("data-address"),
            phone: this.getAttribute("data-phone"),
            image: this.getAttribute("data-image"),
            url: this.getAttribute("data-url"),
          };

          updateLocationCard(locationData);
          highlightActiveLocation(locationData.id);
        });
      });
    }

    // Expose function globally for use in location-search-ajax.js
    window.attachEventListenersToDefaultLocations = attachEventListenersToDefaultLocations;

    // ✅ Update `.locations-list` dynamically while typing
    function updateLocationsList(filteredLocations) {
      if (searchInput.value.length < 3) return; // Keep default list before 3 characters

      locationsList.innerHTML = ""; // Clear previous list

      if (filteredLocations.length === 0) {
        locationsList.innerHTML = `<li class="no-results">No locations found</li>`;
        return;
      }

      filteredLocations.forEach(location => {
        const listItem = document.createElement("li");
        listItem.classList.add("locations-list-item");
        listItem.innerHTML = `
          <a href="#" class="locations-list-link"
            data-id="location-card-${location.id}"
            data-title="${location.title}"
            data-address="${location.address.address_line_1}, ${location.address.city}, ${location.address.state_province} ${location.address.postal_code}"
            data-phone="${location.phone || 'No phone available'}"
            data-image="${location.image || 'images/default-placeholder.jpg'}"
            data-url="${location.link || '#'}">
            <div><?php \Convertiv\Theme\Utils\__sprite('location-dot', 'ms-1'); ?></div>
            <div>${location.title} - ${location.address.postal_code}</div>
          </a>
        `;

        listItem.querySelector("a").addEventListener("click", function(e) {
          e.preventDefault();
          updateLocationCard({
            id: location.id,
            title: location.title,
            address: `${location.address.address_line_1}, ${location.address.city}, ${location.address.state_province} ${location.address.postal_code}`,
            phone: location.phone || "No phone available",
            image: location.image || "images/default-placeholder.jpg",
            url: location.link || "#"
          });
          highlightActiveLocation(location.id);
        });

        locationsList.appendChild(listItem);
      });

      attachEventListenersToDefaultLocations(); // Ensure new list items are interactive
    }

    // ✅ Update the Single Location Card Dynamically
    function updateLocationCard(location) {
      // Get fresh DOM element references each time
      const locationImage = document.getElementById("location-image");
      const locationImageLink = document.getElementById("location-image-link");
      const locationTitle = document.getElementById("location-title");
      const locationAddress = document.getElementById("location-address");
      const moreInfoLink = document.getElementById("more-info-link");

      if (locationImage) locationImage.src = location.image;
      if (locationImageLink) locationImageLink.href = location.url;
      if (locationTitle) {
        locationTitle.textContent = location.title;
        locationTitle.href = location.url;
      }
      if (locationAddress) locationAddress.innerHTML = `${location.address}<br>${location.phone}`;
      if (moreInfoLink) moreInfoLink.href = location.url;
    }

    // ✅ Highlight active location in `.locations-list`
    function highlightActiveLocation(locationId) {
      document.querySelectorAll(".locations-list-link").forEach(item => {
        item.classList.remove("is-active");
        if (item.getAttribute("data-id") === `location-card-${locationId}`) {
          item.classList.add("is-active");
        }
      });
    }

    // Expose functions globally for use in location-search-ajax.js
    window.updateLocationCard = updateLocationCard;
    window.highlightActiveLocation = highlightActiveLocation;

    // ✅ Initialize autoComplete.js
    function initAutoComplete() {
      new autoComplete({
        selector: "#locationSearch",
        threshold: 3,
        placeHolder: "Enter location or ZIP code...",
        data: {
          src: async () => {
            const query = searchInput.value.toLowerCase();
            return locations.filter(loc =>
              loc.title.toLowerCase().includes(query) ||
              (loc.address && loc.address.postal_code.startsWith(query))
            ).slice(0, 5);
          },
          keys: ["title"]
        },
        resultsList: false,
        events: {
          input: {
            focus: ensureAutoCompleteVisibility,
            input: debounce((event) => {
              const query = event.target.value;
              if (query.length >= 3) {
                const filtered = locations.filter(loc =>
                  loc.title.toLowerCase().includes(query.toLowerCase()) ||
                  (loc.address && loc.address.postal_code.startsWith(query))
                ).slice(0, 5);
                updateLocationsList(filtered);
                ensureAutoCompleteVisibility();
              }
            }, 300), // Wait 300ms before processing input
            selection: (event) => {
              const selectedItem = event.detail.selection.value;
              searchInput.value = selectedItem.title;
              updateLocationCard(selectedItem);
              highlightActiveLocation(selectedItem.id);
              hideAutoCompleteList();
            }
          }
        }
      });
    }

    fetchLocations().then(initAutoComplete);
  }
});
